/* @flow */

export default dispatcher => {
  const changeSliderTitle = (newTitle: string, idx) => {
    dispatcher({
      type: 'CHANGE_SLIDER_TITLE',
      value: { newTitle, idx }
    })
  }

  const changeSliderParagraph = (newParagraph: string, idx) => {
    dispatcher({
      type: 'CHANGE_SLIDER_PARAGRAPH',
      value: { newParagraph, idx }
    })
  }

  const addSlide = (activeIdx: number) => {
    dispatcher({
      type: 'ADD_SLIDE',
      value: activeIdx
    })
  }

  const removeSlide = idx => {
    dispatcher({
      type: 'REMOVE_SLIDE',
      value: { idx }
    })
  }

  const changeSlideTitleAlignment = (alignment: string, idx: number) => {
    dispatcher({
      type: 'CHANGE_SLIDE_TITLE_ALIGNMENT',
      value: { alignment, idx }
    })
  }

  const changeSlideParagraphAlignment = (alignment: string, idx: number) => {
    dispatcher({
      type: 'CHANGE_SLIDE_PARAGRAPH_ALIGNMENT',
      value: { alignment, idx }
    })
  }

  return {
    changeSliderTitle,
    changeSliderParagraph,
    addSlide,
    removeSlide,
    changeSlideTitleAlignment,
    changeSlideParagraphAlignment
  }
}
